export enum ESTIMATE_STATUS {
  PENDING = 1,
  SUBMITTED = 11,
  APPROVED = 21,
  DECLINED = 31,
  CANCELLED = 41,
  REVISION = 51,
}

export const ESTIMATE_STATUS_OPTIONS = [
  { value: ESTIMATE_STATUS.PENDING, label: 'PENDING' },
  { value: ESTIMATE_STATUS.SUBMITTED, label: 'SUBMITTED' },
  { value: ESTIMATE_STATUS.APPROVED, label: 'APPROVED' },
  { value: ESTIMATE_STATUS.CANCELLED, label: 'CANCELLED' },
  { value: ESTIMATE_STATUS.DECLINED, label: 'DECLINED' },
  { value: ESTIMATE_STATUS.REVISION, label: 'REVISION' },
]

const OPTIONS = {
  [ESTIMATE_STATUS.PENDING]: {
    value: ESTIMATE_STATUS.PENDING,
    label: 'PENDING',
  },
  [ESTIMATE_STATUS.SUBMITTED]: {
    value: ESTIMATE_STATUS.SUBMITTED,
    label: 'SUBMITTED',
  },
  [ESTIMATE_STATUS.APPROVED]: {
    value: ESTIMATE_STATUS.APPROVED,
    label: 'APPROVED',
  },
  [ESTIMATE_STATUS.CANCELLED]: {
    value: ESTIMATE_STATUS.CANCELLED,
    label: 'CANCELLED',
  },
  [ESTIMATE_STATUS.DECLINED]: {
    value: ESTIMATE_STATUS.DECLINED,
    label: 'DECLINED',
  },
  [ESTIMATE_STATUS.REVISION]: {
    value: ESTIMATE_STATUS.REVISION,
    label: 'REVISION',
  },
}
/*Hiding cancelled for now. This will change in later*/
export const ESTIMATE_STATUSES_ASSOCIATE_WITH_CURRENT_STATUS = {
  [ESTIMATE_STATUS.PENDING]: [
    OPTIONS[ESTIMATE_STATUS.PENDING],
    OPTIONS[ESTIMATE_STATUS.CANCELLED],
    OPTIONS[ESTIMATE_STATUS.SUBMITTED],
  ],
  [ESTIMATE_STATUS.SUBMITTED]: [
    OPTIONS[ESTIMATE_STATUS.SUBMITTED],
    OPTIONS[ESTIMATE_STATUS.APPROVED],
    OPTIONS[ESTIMATE_STATUS.DECLINED],
    OPTIONS[ESTIMATE_STATUS.REVISION],
  ],
  [ESTIMATE_STATUS.REVISION]: [OPTIONS[ESTIMATE_STATUS.SUBMITTED], OPTIONS[ESTIMATE_STATUS.DECLINED]],
  [ESTIMATE_STATUS.APPROVED]: [
    OPTIONS[ESTIMATE_STATUS.APPROVED],
    OPTIONS[ESTIMATE_STATUS.REVISION],
    OPTIONS[ESTIMATE_STATUS.DECLINED],
    OPTIONS[ESTIMATE_STATUS.CANCELLED],
  ],
  [ESTIMATE_STATUS.CANCELLED]: [OPTIONS[ESTIMATE_STATUS.CANCELLED]],
  [ESTIMATE_STATUS.DECLINED]: [OPTIONS[ESTIMATE_STATUS.DECLINED], OPTIONS[ESTIMATE_STATUS.SUBMITTED]],
}

export const ESTIMATE_STATUSES_ASSOCIATE_WITH_CURRENT_STATUS_VENDOR = {
  [ESTIMATE_STATUS.PENDING]: [OPTIONS[ESTIMATE_STATUS.PENDING], OPTIONS[ESTIMATE_STATUS.CANCELLED]],
  [ESTIMATE_STATUS.CANCELLED]: [OPTIONS[ESTIMATE_STATUS.CANCELLED]],
}
